import React, { useContext, useRef, useEffect } from "react";
import Swal from "sweetalert2";

import Footer from "../Templete/Footer";
import Header from "../Templete/Header";

import FormService from "../../Services/FormService";
import LoadingContext from "../../Store/loading-context";
import HttpError from "../../utill/HttpError";

const ContactUs = () => {
  const loadingCtx = useContext(LoadingContext);

  const nameRef = useRef();
  const emailRef = useRef();
  const mobileRef = useRef();
  const subjectRef = useRef();
  const messageRef = useRef();

  useEffect(() => {
    document.title = "Contact Us | FORMAX MONEY";
  }, []);

  const submitHandler = async (e) => {
    e.preventDefault();

    const name = nameRef.current.value;
    const email = emailRef.current.value;
    const mobile = mobileRef.current.value;
    const subject = subjectRef.current.value;
    const message = messageRef.current.value;

    if (!name || !email || !mobile || !subject || !message) {
      Swal.fire("Oops!", "Please fill all required fields.", "error");
      return;
    }

    loadingCtx.startLoading();

    try {
      const responseData = await FormService.contactForm(
        name,
        email,
        mobile,
        subject,
        message,
      );

      const status = responseData.status;
      const message2 = responseData.message;

      if (status === "SUCCESS") {
        nameRef.current.value = "";
        emailRef.current.value = "";
        mobileRef.current.value = "";
        subjectRef.current.value = "";
        messageRef.current.value = "";
        Swal.fire("Success!", message2, "success");
      } else {
        Swal.fire("Opps!", message2, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  // Google Maps embed URL for Formax It Solutions Private Limited (Barasat, Kolkata)
  const mapEmbedUrl =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3682.456789012345!2d88.4321!3d22.7123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f899f2d1613a0b%3A0x8b7693dab1225dc8!2sFormax%20It%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1712345678901!5m2!1sen!2sin";

  return (
    <>
      <Header />

      {/* Page Hero */}
      <section className="page-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p>
            Get in touch with FORMAX MONEY for BC Agent registration,
            partnership inquiries, or any support regarding our financial
            inclusion services.
          </p>
        </div>
      </section>

      <div className="container">
        <div className="contact-grid">
          {/* Left side: contact info cards */}
          <div className="contact-info">
            <div className="info-card">
              <i className="fas fa-map-marker-alt"></i>
              <h3>Registered Office</h3>
              <p>
                N0060, Mochpole, Near Junior School, Nabapally, Barasat, Kolkata
                - 700126, West Bengal, India
              </p>
            </div>
            <div className="info-card">
              <i className="fas fa-phone-alt"></i>
              <h3>Contact & Support</h3>
              <p>
                <strong>Phone:</strong>{" "}
                <a href="tel:917890090500">+91 7890090500</a>
              </p>
              <p>
                <strong>WhatsApp:</strong>{" "}
                <a href="https://wa.me/917890090500">+91 7890090500</a>
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:support@formaxmoney.in">
                  support@formaxmoney.in
                </a>
              </p>
              <p>
                <strong>Business Hours:</strong> Mon-Sat, 10:00 AM – 7:00 PM
              </p>
            </div>
            <div className="info-card">
              <i className="fas fa-building"></i>
              <h3>Legal Information</h3>
              <p>
                <strong>Company:</strong> FORMAX IT SOLUTIONS PRIVATE LIMITED
              </p>
              <p>
                <strong>CIN:</strong> U72900WB2018PTC228240
              </p>
              <p>
                <strong>GSTIN:</strong> 19AADCF5125F1ZT
              </p>
            </div>
          </div>

          {/* Right side: contact form */}
          <div className="contact-form">
            <h2 style={{ marginBottom: "24px", fontSize: "1.8rem" }}>
              Send us a Message
            </h2>
            <form onSubmit={submitHandler}>
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  ref={nameRef}
                  required
                  placeholder="Enter your full name"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  ref={emailRef}
                  required
                  placeholder="you@example.com"
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Mobile Number *</label>
                <input
                  type="tel"
                  id="phone"
                  ref={mobileRef}
                  required
                  placeholder="9876543210"
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Inquiry Type *</label>
                <select id="subject" ref={subjectRef} required>
                  <option value="">-- Select Inquiry Type --</option>
                  <option value="Become a BC Agent">Become a BC Agent</option>
                  <option value="BC Agent Support">BC Agent Support</option>
                  <option value="Partnership Inquiry">
                    Partnership Inquiry
                  </option>
                  <option value="Technical Support">Technical Support</option>
                  <option value="AEPS / DMT Issue">AEPS / DMT Issue</option>
                  <option value="Commission Related">Commission Related</option>
                  <option value="Feedback / Suggestion">
                    Feedback / Suggestion
                  </option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  ref={messageRef}
                  rows="5"
                  required
                  placeholder="Please describe your query or requirement in detail..."
                ></textarea>
              </div>
              <button type="submit" className="btn-submit">
                <i className="fas fa-paper-plane"></i> Send Message
              </button>
              <p className="form-footer-note">
                <i className="fas fa-lock"></i> Your information is secure.
                We'll respond within 24 hours.
              </p>
            </form>
          </div>
        </div>

        {/* Google Map Embed */}
        <div className="map-container">
          <iframe
            title="FORMAX IT SOLUTIONS - Registered Office"
            src={mapEmbedUrl}
            width="100%"
            height="100%"
            style={{ border: 0, borderRadius: "32px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      <Footer />

      <style>{`
        .page-hero {
          background: linear-gradient(135deg, #0A2540 0%, #1A3A5F 100%);
          padding: 60px 0 70px;
          text-align: center;
        }
        .page-hero h1 {
          font-size: 2.8rem;
          margin-bottom: 16px;
          color: white;
          font-weight: 700;
        }
        .page-hero p {
          color: rgba(255,255,255,0.85);
          max-width: 600px;
          margin: 0 auto;
          font-size: 1.1rem;
        }
        
        .contact-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 48px;
          margin: 60px 0;
        }
        
        .contact-info {
          flex: 1;
          min-width: 280px;
        }
        
        .contact-form {
          flex: 1.5;
          min-width: 300px;
          background: white;
          padding: 36px;
          border-radius: 32px;
          box-shadow: 0 20px 35px -12px rgba(0,0,0,0.1);
          border: 1px solid #eef2ff;
        }
        
        .info-card {
          background: white;
          border-radius: 28px;
          padding: 28px;
          margin-bottom: 24px;
          box-shadow: 0 10px 25px -5px rgba(0,0,0,0.05);
          border: 1px solid #eef2ff;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .info-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 30px -12px rgba(0,0,0,0.12);
          border-color: rgba(212, 175, 55, 0.3);
        }
        
        .info-card i {
          font-size: 2rem;
          color: #D4AF37;
          margin-bottom: 16px;
        }
        
        .info-card h3 {
          margin-bottom: 12px;
          font-size: 1.3rem;
          color: #0A2540;
          font-weight: 700;
        }
        
        .info-card p, .info-card a {
          color: #475569;
          text-decoration: none;
          line-height: 1.6;
          margin-bottom: 8px;
        }
        
        .info-card a:hover {
          color: #D4AF37;
        }
        
        .small-text {
          font-size: 0.8rem;
          color: #D4AF37;
        }
        
        .form-group {
          margin-bottom: 20px;
        }
        
        .form-group label {
          font-weight: 600;
          display: block;
          margin-bottom: 8px;
          color: #0A2540;
        }
        
        .form-group input, 
        .form-group select, 
        .form-group textarea {
          width: 100%;
          padding: 14px 18px;
          border-radius: 12px;
          border: 1px solid #cbd5e1;
          font-size: 1rem;
          transition: 0.2s;
          font-family: 'Inter', sans-serif;
          background: #fff;
        }
        
        .form-group textarea {
          border-radius: 16px;
          resize: vertical;
        }
        
        .form-group input:focus, 
        .form-group textarea:focus, 
        .form-group select:focus {
          outline: none;
          border-color: #D4AF37;
          box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.15);
        }
        
        .btn-submit {
          background: linear-gradient(135deg, #D4AF37 0%, #B8960F 100%);
          color: #0A2540;
          padding: 14px 32px;
          border-radius: 12px;
          font-weight: 700;
          border: none;
          cursor: pointer;
          width: 100%;
          font-size: 1rem;
          transition: 0.3s;
        }
        
        .btn-submit:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(212, 175, 55, 0.3);
        }
        
        .form-footer-note {
          font-size: 0.75rem;
          margin-top: 16px;
          text-align: center;
          color: #64748b;
        }
        
        .form-footer-note i {
          color: #D4AF37;
          margin-right: 4px;
        }
        
        .map-container {
          width: 100%;
          height: 380px;
          border-radius: 32px;
          overflow: hidden;
          margin: 30px 0 60px;
          box-shadow: 0 10px 30px -8px rgba(0,0,0,0.1);
          border: 1px solid rgba(212, 175, 55, 0.2);
        }
        
        @media (max-width: 768px) {
          .page-hero h1 { 
            font-size: 2rem; 
          }
          .page-hero p {
            font-size: 1rem;
            padding: 0 20px;
          }
          .map-container { 
            height: 280px; 
          }
          .contact-form {
            padding: 24px;
          }
          .info-card {
            padding: 20px;
          }
        }
        
        @media (max-width: 576px) {
          .page-hero {
            padding: 40px 0 50px;
          }
          .page-hero h1 {
            font-size: 1.6rem;
          }
          .contact-grid {
            gap: 30px;
            margin: 40px 0;
          }
        }
      `}</style>
    </>
  );
};

export default ContactUs;
